import React from 'react';
import { FormGroup } from 'reactstrap';
import { FMessage } from '../../hoc/IntlComponents';
import Icon from '../Icon/Icon';
import CustomControl from '../CustomControl/CustomControl';
import { Button } from 'reactstrap';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../config';

const ReplyHelp = ({ onSubmit, loading, selected, replyId }) => {
  const onSelectValue = (value) => onSubmit(value);
  return (
    <FormGroup className="ticket-help" check>
      <button
        className="ticket-help-btn-question"
        onClick={() => onSelectValue('0')}
        id={`${replyId}-help-questions`}
      >
        <SVG
          className="item-bin-icon"
          src={`${STATIC_PATH}/img/action-icons/question-icon.svg`}
          height="20"
          width="20"
          cacheRequests
        />
      </button>
      <button
        className="ticket-help-btn-good"
        onClick={() => onSelectValue('-1')}
        id={`${replyId}-help-good`}
      >
        <SVG
          className="item-bin-icon"
          src={`${STATIC_PATH}/img/action-icons/like-icon.svg`}
          height="20"
          width="20"
          cacheRequests
        />
      </button>
      <button
        className="ticket-help-btn-bad"
        onClick={() => onSelectValue('1')}
        id={`${replyId}-help-bad`}
      >
        <SVG
          className="item-bin-icon"
          src={`${STATIC_PATH}/img/action-icons/like-icon.svg`}
          height="20"
          width="20"
          cacheRequests
        />
      </button>
    </FormGroup>
  );
};

export default ReplyHelp;
